import { Component, OnInit, AfterViewInit } from '@angular/core';
import items from '../../../../../assets/json/placement-excellence/receives-quotations.json';
import { ActivatedRoute } from '@angular/router'; 
import { PlacementExcellenceService } from 'src/app/services/placement-excellence.service';

@Component({
    selector: 'app-receives-quotations',
    templateUrl: './receives-quotations.component.html',
    styleUrls: ['./receives-quotations.component.css'],
    standalone: false
})
export class ReceivesQuotationsComponent implements AfterViewInit {

  tableItems = items;

  constructor (private route: ActivatedRoute, private placementExcellenceService: PlacementExcellenceService) { }

  ngAfterViewInit() {
    this.route.fragment.subscribe(f => this.placementExcellenceService.scroolToElementById(f));
  }

}
